/**
 * This controller makes sure that the value of the element it is connected to starts with the
 * given prefix.
 */

import { Controller } from '@hotwired/stimulus';

// Connects to data-controller="input-prefix"
export default class extends Controller {
  static values = {
    prefix: String,
  };

  connect() {}

  setPrefix() {
    if (this.element.value.indexOf(this.prefixValue) == 0) {
      // The value starts with prefix. It is the new default, i.e. fallback for the else branch.
      this.element.defaultValue = this.element.value;
    } else {
      // The prefix is not correct. Go back to the last good value.
      this.element.value = this.element.defaultValue;
    }
  }
}
